import { t } from '@procumi/shared';
/** Copiere în clipboard, cu mesajul din demo când browserul nu permite. */
export async function copyText(text: string, toast: (m: string) => void): Promise<void> {
  try {
    await navigator.clipboard.writeText(text);
    toast(t('Copiat'));
  } catch {
    toast(t('Copierea nu e permisă aici. Selectează textul manual.'));
  }
}
